var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTirAuButRugby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #47464b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.57,77.76c-.25,0-.45-.2-.45-.45V22.64c0-.25.2-.45.45-.45s.45.2.45.45v54.67c0,.25-.2.45-.45.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.43,77.76c-.25,0-.45-.2-.45-.45V22.64c0-.25.2-.45.45-.45s.45.2.45.45v54.67c0,.25-.2.45-.45.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.98,
    y: 66.76,
    width: 4.9,
    height: 10.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.12,
    y: 66.76,
    width: 4.9,
    height: 10.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.43,62.09h-26.86c-.25,0-.45-.2-.45-.45s.2-.45.45-.45h26.86c.25,0,.45.2.45.45s-.2.45-.45.45Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.24,24.7h11.46v3.01h-3.85v9.19h-3.77v-9.19h-3.85v-3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.12,55.35h-4.28l-.6,2.01h-3.85l4.59-12.2h4.11l4.59,12.2h-3.95l-.61-2.01ZM76.34,52.71l-1.35-4.39-1.33,4.39h2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.63,65.61h7.06c1.18,0,2.08.29,2.71.87.63.58.95,1.3.95,2.16,0,.72-.22,1.34-.67,1.86-.3.34-.74.62-1.32.82.88.21,1.52.57,1.93,1.09s.62,1.16.62,1.94c0,.63-.15,1.2-.44,1.71s-.7.9-1.21,1.2c-.32.18-.79.32-1.43.4-.85.11-1.41.17-1.69.17h-6.51v-12.2ZM73.43,70.4h1.64c.59,0,1-.1,1.23-.3.23-.2.35-.5.35-.88,0-.36-.12-.63-.35-.83-.23-.2-.63-.3-1.2-.3h-1.66v2.31ZM73.43,75.2h1.92c.65,0,1.11-.12,1.37-.35s.4-.54.4-.93c0-.36-.13-.65-.4-.87-.26-.22-.72-.33-1.38-.33h-1.91v2.47Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTirAuButRugby);
export default __webpack_public_path__ + "static/media/tir_au_but_rugby.38b9dac9c9d90e352e7ef1e47b4c8662.svg";
export { ForwardRef as ReactComponent };